'use client'
import { useTranslations } from 'next-intl'
import { useRouter } from '@/i18n/routing'
import { useBackgroundRemoverStore } from '@/stores/use-background-remover-store'
import { FileDropZone } from '@/components/shared/FileDropZone'
import { ToolStepIndicator } from '@/components/shared/ToolStepIndicator'
import { trackToolEvent } from '@/lib/utils/analytics'

export function BgUploadStep() {
    const t = useTranslations('Upload')
    const router = useRouter()
    const addFiles = useBackgroundRemoverStore(s => s.addFiles)
    const reset = useBackgroundRemoverStore(s => s.reset)

    const handleFilesAdded = (files: File[]) => {
        reset()
        addFiles(files, f => f.type.startsWith('image/'))
        const accepted = files.filter(f => f.type.startsWith('image/'))
        if (accepted.length > 0) {
            trackToolEvent('tool_upload_started', {
                tool: 'remove-background',
                file_count: accepted.length,
                file_kind: 'image',
            })
        }
        router.push('/remove-background/configurar')
    }

    return (
        <div className="mx-auto max-w-4xl">
            <ToolStepIndicator currentStep={1} baseUrl="/remove-background" />
            <div className="rounded-3xl bg-white p-4 shadow-2xl shadow-slate-200/50">
                <FileDropZone
                    accept="image/*"
                    icon="auto_fix_high"
                    title={t('selectImagesBg')}
                    subtitle={t('subtitleBg')}
                    onFilesAdded={handleFilesAdded}
                />
            </div>
        </div>
    )
}
